import React from 'react';
import { useAuth, useT } from '@repo/common';

const HeaderText = ({ isAdmin }) => {
  const { user } = useAuth();
  const t = useT();

  return (
    <div
      className={`flex ${
        isAdmin ? 'max-w-[1462px]' : 'max-w-[1166px]'
      } w-full tabletH:pb-[30px] justify-between items-center`}
    >
      <div className='flex flex-col typo-h5 text-text-primary'>
        <div>{t('Hello,', '안녕하세요,')}</div>
        <div>{isAdmin ? t('Admin', '관리자') : `${user?.firstName} ${user?.lastName}`}</div>
      </div>
    </div>
  );
};

export default HeaderText;
